// ContactDetails.js
import React from "react";
import { Box, Typography, Paper, Link, Grid, Button } from "@mui/material";
import "./contact-details.css"; // Custom CSS for specific styles

const ContactDetails = ({ handleSubmit, prevStep }) => {
  return (
    <Box className='contact-container'>
      <Paper className='contact-info-container'>
        <Typography variant='h4' className='contact-title' gutterBottom>
          Contact Details
        </Typography>

        {/* Little Norway Section */}
        <Box mb={3}>
          <Typography variant='h6' className='section-header' gutterBottom>
            LITTLE NORWAY
          </Typography>
          <Typography variant='body1'>
            <strong>Chantelle Jackson</strong>
            <br />
            Email address:{" "}
            <Link href='mailto:chantelle@activecare.org.uk' underline='hover'>
              chantelle@activecare.org.uk
            </Link>
            <br />
            Phone number: 07482506964
          </Typography>
        </Box>

        {/* Responsible Individual Section */}
        <Box mb={3}>
          <Typography variant='h6' className='section-header' gutterBottom>
            LITTLE NORWAY RESPONSIBLE INDIVIDUAL
          </Typography>
          <Typography variant='body1'>
            <strong>Janice Dobbin</strong>
            <br />
            Email address:{" "}
            <Link href='mailto:bev@activecare.org.uk' underline='hover'>
              bev@activecare.org.uk
            </Link>
            <br />
            Phone number: 07809509466
          </Typography>
        </Box>

        {/* Childline Section */}
        <Grid container mt={3}>
          <Grid item sm={3} lg={3}>
            <img src='./CYPImages/contact/childline.png' alt='Child line' className='child-line' />
          </Grid>
          <Grid item sm={9} lg={9}>
            <Typography variant='h6' className='section-header-childline' gutterBottom>
              CHILDLINE
            </Typography>
            <Typography variant='body1'>
              Childline is a free 24hour counselling service for children and young people in the UK  where you can talk
              to someone about your problems at any time, day, or night. You can call them on <strong>0800 1111</strong>{" "}
              You can also visit their website at{" "}
              <Link href='https://www.childline.org.uk' target='_blank' underline='hover'>
                www.childline.org.uk
              </Link>
              .
            </Typography>
          </Grid>
        </Grid>

        {/* Ofsted Section */}
        <Grid container mt={3}>
          <Grid item sm={3} lg={3}>
            <img src='./CYPImages/contact/ofsted.png' alt='Ofsted' className='ofsted' />
          </Grid>
          <Grid item sm={9} lg={9}>
            <Typography variant='h6' className='section-header-ofsted' gutterBottom>
              OFSTED
            </Typography>
            <Typography variant='body1'>
              Little Norway is visited by an Ofsted inspector from at least once a year. Ofsted is the office for
              Standards in Education, Children services and Skills. They send an inspection to the home to look around
              where you live and make sure you are safe and being looked after properly.
            </Typography>
          </Grid>
        </Grid>

        {/* NSPCC Section */}
        <Grid container mt={3}>
          <Grid item sm={3} lg={3}>
            <img src='./CYPImages/contact/nspcc.png' alt='nspcc' className='nspcc' />
          </Grid>
          <Grid item sm={9} lg={9}>
            <Typography variant='h6' className='section-header-nspcc' gutterBottom>
              NSPCC
            </Typography>
            <Typography variant='body1'>
              The National Society for the Prevention of Cruelty to children (NSPPC) is a large charity. Its mission is
              to work for a better society where all children are loved, valued, and cared for in other to fulfil their
              potential. You can access their website at{" "}
              <Link href='https://www.nspcc.org.uk' target='_blank' underline='hover'>
                www.nspcc.org.uk
              </Link>{" "}
              or contact them on their 24-hour helpline by calling :<strong>0808 800 5000</strong>.
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Grid container justifyContent='space-between' alignItems='center' mt={2}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button type='submit' variant='contained' color='primary' onClick={handleSubmit}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactDetails;
